"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shared_1 = require("@cian/peperrors/shared");
var convertLogMeta_1 = require("./convertLogMeta");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var ensureErrorIsError = function (error) {
    return error instanceof Error || error instanceof shared_1.GenericError ? error : new Error(String(error));
};
var formatErrorLog = function (exception, level, meta) {
    if (level === void 0) { level = 'error'; }
    var error = ensureErrorIsError(exception);
    var name = error.name, message = error.message, stack = error.stack, constructor = error.constructor;
    var exceptionType = error.type || name;
    return {
        level: level,
        exception: (name || constructor.name) + " " + message + " " + stack,
        exception_type: exceptionType,
        exception_message: message,
        exception_data: convertLogMeta_1.convertMetaToKeyValue(meta),
    };
};
exports.formatErrorLog = formatErrorLog;
//# sourceMappingURL=formatErrorLog.js.map